/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import TextField from "@mui/material/TextField";


export default function TotpInput({label, disabled, value, setValue}) {
    return <TextField
        label={label ? label : "Enter Code"}
        disabled={disabled}
        InputLabelProps={{shrink: true}}
        inputProps={{
            maxLength: 6,
            autoComplete:"one-time-code",
            inputmode:"numeric",
            pattern: "\\d{6}",
        }}
        value={value}
        inputmode="numeric"
        onChange={(event) => {
            setValue(event.target.value.replace(/[^0-9]/, ''))
        }}
        sx={{
            width: '300px',
            margin: 2,
            '& .MuiInputBase-input': {
                fontSize: '22px',
                fontWeight: 'bold',
                letterSpacing: 5,
                paddingLeft:'98px',
            }
        }}
    />
}
